// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { createCheckoutSessionsCheckoutSessions } from "./checkout_sessions.js";
export const createCheckoutSessionsExtensions = (client) => createCheckoutSessionsCheckoutSessions(client);
export const checkoutSessionsOperations = [
    { method: "POST", path: "/checkout_sessions/:id/cancel", accessor: "checkoutSessions.cancel" },
    { method: "POST", path: "/checkout_sessions/:id/complete", accessor: "checkoutSessions.complete" },
    { method: "POST", path: "/checkout_sessions", accessor: "checkoutSessions.create" },
    { method: "GET", path: "/checkout_sessions/:id", accessor: "checkoutSessions.retrieve" },
    { method: "POST", path: "/checkout_sessions/:id", accessor: "checkoutSessions.update" },
];
//# sourceMappingURL=index.js.map